<div *ngFor="let alert of alerts" class="alert-app text-center {{cssClass(alert)}}">
  <a class="close" (click)="removeAlert(alert)">&times;</a>
  <span [innerHTML]="alert.message"></span>
</div>
